<div class="image" [class.error]="showFallback">
	@if (!showFallback) {
		<img [alt]="alt" [attr.loading]="loading" [src]="src" (error)="onError()" />
	} @else {
		@if (errorTemplate) {
			<ng-container [ngTemplateOutlet]="errorTemplate" />
		} @else {
			<i class="fa fa-image"> </i>
			@if (errorText) {
				<p>
					{{ errorText }}
				</p>
			}
		}
	}
</div>
